module.exports = __webpack_public_path__ + "img/DashboardCustomizeOutlined.da7b4f55.svg";